import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import acessoIcon from "../../assets/icons/perfil.png";

import AcessosService from "../../services/AcessosService";

export default function AcessosForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idAcesso: null,
    nome: "",
    descricao: "",
    regra: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE"); 

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idAcesso: null,
        nome: "",
        descricao: "",
        regra: "",
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idAcesso: itemSelecionado.idAcesso,
        nome: itemSelecionado.nome || "",
        descricao: itemSelecionado.descricao || "",
        regra: itemSelecionado.regra || "",
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.nome) e.nome = "Informe o nome";
    if (!form.descricao) e.descricao = "Informe a descrição";
    if (!form.regra) e.regra = "Informe a regra";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {

        const payload_create = { ...form };

        await AcessosService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Acesso criado com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

      if (modo === "alterar") {

        const payload_update = { ...form };

        await AcessosService.update(form.idAcesso, payload_update);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Acesso atualizado com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

       onClose();
    } catch (error) {
        setRetorno({
          tipo: "erro",
          mensagem:
            modo === "novo"
              ? "Erro ao criar Acesso."
              : "Erro ao atualizar Acesso.",
        });

        setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={acessoIcon} alt="Acesso" className="icon" />
          {modo === "novo" ? "Cadastro de acessos" : "Alterar acesso"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome: *</div>
          <input name="nome" value={form.nome} onChange={handleChange} />
          {errors.nome && <span style={{ color: "red" }}>{errors.nome}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição: *</div>
          <input
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
          />
          {errors.descricao && (
            <span style={{ color: "red" }}>{errors.descricao}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Regra: *</div>
          <input name="regra" value={form.regra} onChange={handleChange} />
          {errors.regra && <span style={{ color: "red" }}>{errors.regra}</span>}
        </div>

        <div className="Form-Interno-alinhamento-button">
          <button type="button"
            className="Form-Interno-alinhamento-button-inativo" onClick={onClose} >
              Inativo
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
